"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelect = void 0;
const react_1 = __importStar(require("react"));
const react_outside_click_handler_1 = __importDefault(require("react-outside-click-handler"));
const icons_1 = require("../../../theme/icons");
const Checkbox_1 = require("../Checkbox/Checkbox");
const MultiSelect_styles_1 = require("./MultiSelect.styles");
const MultiSelect = ({ level1Items, level2Items, onChange, allItemsSelectedLabel, itemsSelectedLabel, noItemsSelectedLabel, selectAllLabel, }) => {
    const [allLevel1Items, setAllLevel1Items] = (0, react_1.useState)(level1Items);
    const [allLevel2Items, setAllLevel2Items] = (0, react_1.useState)(level2Items);
    const [selectAll, setSelectAll] = (0, react_1.useState)(false);
    const [expandedLevels, setExpandedLevels] = (0, react_1.useState)({});
    const [selectBoxOpen, setSelectBoxOpen] = (0, react_1.useState)(false);
    const [totalCheckedCount, setTotalCheckedCount] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        onChange(allLevel1Items, allLevel2Items);
        const count = allLevel1Items.filter((level1) => level1.checked && level1.level2Ids.length === 0).length +
            allLevel2Items.filter((level2) => level2.checked).length;
        setTotalCheckedCount(count);
    }, [allLevel1Items, allLevel2Items, onChange]);
    const handleLevel2Change = (0, react_1.useCallback)((level2Id) => {
        const updatedLevel2Items = allLevel2Items.map((level2) => level2.id === level2Id ? Object.assign(Object.assign({}, level2), { checked: !level2.checked }) : level2);
        const updatedLevel1Items = allLevel1Items.map((level1) => {
            const level2ItemsForLevel1 = updatedLevel2Items.filter((level2) => level1.level2Ids.includes(level2.id));
            const allChecked = level2ItemsForLevel1.length > 0 ? level2ItemsForLevel1.every((level2) => level2.checked) : level1.checked;
            const noneChecked = level2ItemsForLevel1.every((level2) => !level2.checked);
            return Object.assign(Object.assign({}, level1), { checked: allChecked, intermediate: !allChecked && !noneChecked });
        });
        setAllLevel2Items(updatedLevel2Items);
        setAllLevel1Items(updatedLevel1Items);
    }, [allLevel1Items, allLevel2Items]);
    const handleLevel1Change = (0, react_1.useCallback)((level1Id) => {
        var _a;
        const updatedLevel1Items = allLevel1Items.map((level1) => {
            if (level1.id === level1Id) {
                if (level1.intermediate) {
                    return Object.assign(Object.assign({}, level1), { checked: false, intermediate: false });
                }
                return Object.assign(Object.assign({}, level1), { checked: !level1.checked, intermediate: false });
            }
            return level1;
        });
        const isLevel1Checked = ((_a = updatedLevel1Items.find((l1) => l1.id === level1Id)) === null || _a === void 0 ? void 0 : _a.checked) || false;
        const updatedLevel2Items = allLevel2Items.map((level2) => {
            var _a;
            const isAssociatedWithLevel1 = (_a = allLevel1Items.find((l1) => l1.id === level1Id)) === null || _a === void 0 ? void 0 : _a.level2Ids.includes(level2.id);
            if (isAssociatedWithLevel1) {
                return Object.assign(Object.assign({}, level2), { checked: isLevel1Checked });
            }
            return level2;
        });
        setAllLevel1Items(updatedLevel1Items);
        setAllLevel2Items(updatedLevel2Items);
    }, [allLevel1Items, allLevel2Items]);
    const handleSelectAllChange = (0, react_1.useCallback)(() => {
        const newSelectAllState = !selectAll;
        setSelectAll(newSelectAllState);
        const updatedLevel1Items = allLevel1Items.map((level1) => (Object.assign(Object.assign({}, level1), { checked: newSelectAllState, intermediate: false })));
        const updatedLevel2Items = allLevel2Items.map((level2) => (Object.assign(Object.assign({}, level2), { checked: newSelectAllState })));
        setAllLevel1Items(updatedLevel1Items);
        setAllLevel2Items(updatedLevel2Items);
    }, [allLevel1Items, allLevel2Items, selectAll]);
    (0, react_1.useEffect)(() => {
        const allLevel1Checked = allLevel1Items.every((level1) => level1.checked);
        const allLevel2Checked = allLevel2Items.every((level2) => level2.checked);
        setSelectAll(allLevel1Checked && allLevel2Checked);
    }, [allLevel1Items, allLevel2Items]);
    const toggleExpand = (id) => {
        setExpandedLevels((prev) => (Object.assign(Object.assign({}, prev), { [id]: !prev[id] })));
    };
    const onOutsideClick = (0, react_1.useMemo)(() => () => {
        if (selectBoxOpen) {
            setSelectBoxOpen(false);
        }
    }, [selectBoxOpen]);
    const [headingLabel, setHeadingLabel] = (0, react_1.useState)(noItemsSelectedLabel);
    (0, react_1.useEffect)(() => {
        const getHeaderLabel = () => {
            if (totalCheckedCount === 0) {
                return noItemsSelectedLabel;
            }
            const totalItemsCount = level1Items.reduce((count, level1) => count + (level1.level2Ids.length > 0 ? 0 : 1), level2Items.length);
            if (totalCheckedCount === totalItemsCount) {
                return allItemsSelectedLabel;
            }
            return `${totalCheckedCount} ${itemsSelectedLabel}`;
        };
        setHeadingLabel(getHeaderLabel());
    }, [totalCheckedCount, noItemsSelectedLabel, allItemsSelectedLabel, itemsSelectedLabel, level1Items, level2Items]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MultiSelect_styles_1.HeadingWrapper, { onClick: () => {
                setSelectBoxOpen(!selectBoxOpen);
            } }, headingLabel),
        selectBoxOpen && (react_1.default.createElement(react_outside_click_handler_1.default, { onOutsideClick: onOutsideClick },
            react_1.default.createElement(MultiSelect_styles_1.MultiSelectWrapper, null,
                react_1.default.createElement(MultiSelect_styles_1.Wrapper, null,
                    react_1.default.createElement(Checkbox_1.Checkbox, { checked: selectAll ||
                            (allLevel1Items.every((level1) => level1.checked) && allLevel2Items.every((level2) => level2.checked)), label: selectAllLabel, onChange: handleSelectAllChange, disabled: false, intermediate: selectAll &&
                            !allLevel1Items.every((level1) => level1.checked &&
                                level1.level2Ids.every((id) => { var _a; return (_a = allLevel2Items.find((level2) => level2.id === id)) === null || _a === void 0 ? void 0 : _a.checked; })) }),
                    react_1.default.createElement(MultiSelect_styles_1.Divider, null),
                    level1Items.map((level1) => (react_1.default.createElement(MultiSelect_styles_1.Level1Wrapper, { key: level1.id },
                        react_1.default.createElement(MultiSelect_styles_1.Level1Header, null,
                            level1.level2Ids.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(MultiSelect_styles_1.Chevron, { onClick: () => toggleExpand(level1.id) }, expandedLevels[level1.id] ? react_1.default.createElement(icons_1.ArrowDropDown, null) : react_1.default.createElement(icons_1.ArrowRight, null)),
                                " ")),
                            react_1.default.createElement(Checkbox_1.Checkbox, { checked: level1.checked, label: level1.name, onChange: () => handleLevel1Change(level1.id), disabled: false, intermediate: level1.intermediate })),
                        expandedLevels[level1.id] && (react_1.default.createElement(MultiSelect_styles_1.Level2List, null, level1.level2Ids.map((level2Id) => {
                            const level2 = allLevel2Items.find((level2) => level2.id === level2Id);
                            return (react_1.default.createElement(MultiSelect_styles_1.Level2Wrapper, { key: level2Id },
                                react_1.default.createElement(Checkbox_1.Checkbox, { checked: (level2 === null || level2 === void 0 ? void 0 : level2.checked) || false, label: (level2 === null || level2 === void 0 ? void 0 : level2.name) || "", onChange: () => handleLevel2Change(level2Id), disabled: false, intermediate: false })));
                        }))))))))))));
};
exports.MultiSelect = MultiSelect;
//# sourceMappingURL=MultiSelect.js.map